<template>
  <BaseModal
    :value="dialogState"
    :modal-title="$t('organization_tag_delete_dialog.title')"
    @click:outside="close"
    @close="close"
  >
    <template #modal>
      <BaseParagraph v-text="$t('organization_tag_delete_dialog.instruction')" />
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="close"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton color="secondary" type="primary" @click="submit">
        {{ $t("utils.delete") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>



<script>
import TagApi from "@/modules/Folder/Services/tag.api.js";

export default {
  name: "OperationTagDeleteDialog",
  props: {
    dialogState: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: Object,
      default: null,
    },
  },
  methods: {
    close() {
      this.$emit("closed");
    },
    async submit() {
      try {
        if (this.tag) {
          await TagApi.deleteOrganizationTag(
            this.$route.params.organizationId,
            this.tag.id
          );
          this.$store.dispatch("snackbar/active", {
            message: this.$t("utils.success"),
            type: "SUCCESS",
          });
          this.$emit("deleted");
        }
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.$emit("closed");
    },
  },
};
</script>



<style lang="scss" scoped>
</style>